module.exports = __webpack_public_path__ + "static/img/7.62c28a4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/2/1/eng/7.png
// module id = EPRn
// module chunks = 0